// extracted by mini-css-extract-plugin
export default {"checkbox":"optionTemplate_checkbox__BxFpQ"};